import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["vatTreatment", "notes"]
  static values = { templates: Object }

  connect() {
    // Falls das Formular geladen wird und bereits ein Wert ausgewählt ist,
    // befüllen wir das Feld nur, wenn es aktuell noch komplett leer ist.
    if (this.notesTarget.value.trim() === "") {
      this.updateNotes()
    }
  }

  updateNotes() {
    const selectedTreatment = this.vatTreatmentTarget.value

    // Holt den passenden übersetzten Text aus dem übergebenen JSON-Value
    const templateText = this.templatesValue[selectedTreatment] || ""

    // Schreibt den Text in das Textarea-Feld
    this.notesTarget.value = templateText
  }
}
